import React, { PureComponent } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { keyBy } from 'lodash';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import cns from 'classnames';
import copyIdToClipboard from '../../../../../shared/utils/AdminUtils';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import VerbTable from '../../../../../shared/components/VerbTable';
import VerbSelect from '../../../../../shared/components/formComponents/inputs/VerbSelect';
import {
    LEARNING_ASSET_TYPE_OBJECT,
    ASSET_TYPE_ICONS,
    LEARNING_ASSET_DURATIONS
} from '../../../../../shared/Constants';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import VerbDropdownButton from '../../../../../shared/components/VerbDropdownButton';

export default class CollectionContentTable extends PureComponent {
    static propTypes = {
        learningAssetsById: PropTypes.object,
        currentValues: PropTypes.object,
        selectedTrackId: PropTypes.string,
        selectedTrack: PropTypes.object,
        toggleLearningAssetLock: PropTypes.func,
        handleLearningAssetChange: PropTypes.func,
        handleContentAddition: PropTypes.func,
        fields: PropTypes.object,
        handleContentRemoval: PropTypes.func,
        label: PropTypes.string,
        getFormFieldValue: PropTypes.func,
        history: PropTypes.shape({
            push: PropTypes.func
        })
    };

    constructor(props) {
        super(props);

        this.state = {
            updatingLock: false
        };
    }

    _getAssetTypeIcon = (learningAsset) => {
        const currentType = learningAsset && learningAsset.type ? learningAsset.type.toUpperCase() : 'INTERACTIVE';
        return ASSET_TYPE_ICONS[currentType];
    };

    _handleLockClick = (content, index) => {
        const { toggleLearningAssetLock } = this.props;

        this.setState({ updatingLock: true }, () => {
            toggleLearningAssetLock(content, index);
            return this.setState({ updatingLock: false });
        });
    };

    _buildTable = (fields, learningAssetsById) => {
        const { getFormFieldValue } = this.props;
        if (fields && fields.length > 0) {
            return (
                <VerbTable striped={false} bordered={false} hover={true}>
                    <thead>
                        <tr>
                            <th className={'buttonCell'} style={{ width: '33.33333%' }}>
                                ACTIONS
                            </th>
                            <th style={{ width: '16.66667%' }}>LEARNING ASSET</th>
                            <th className={'text-center'}>STATUS</th>
                            <th className={'text-center'}>TYPE</th>
                            <th className={'text-center'}>LICENSE</th>
                            <th className={'text-center'} style={{ width: '16.66667%' }}>
                                DURATION
                            </th>
                            <th className={'text-center'}>ACTIVE?</th>
                            <th className={'text-center'} style={{ width: '41.66667%' }}>
                                LABEL
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((fieldName, index) => {
                            const content = getFormFieldValue(fieldName) || {};
                            const learningAsset = (learningAssetsById && learningAssetsById[content.id]) || {};
                            const assetTypeIcon = this._getAssetTypeIcon(learningAsset);
                            const learningAssetDuration = LEARNING_ASSET_DURATIONS();
                            const tooltip = (
                                <Tooltip id={'tooltip'}>
                                    {LEARNING_ASSET_TYPE_OBJECT[learningAsset.type]
                                        ? LEARNING_ASSET_TYPE_OBJECT[learningAsset.type].label
                                        : ''}
                                </Tooltip>
                            );
                            const subscriptionTypeToolTip = (
                                <Tooltip id={'tooltip'}>
                                    {learningAsset.subscriptionType === 'ExclusiveCompanyLicense'
                                        ? 'Exclusive Company License'
                                        : 'Available For All'}
                                </Tooltip>
                            );
                            const lockedToolTip = (
                                <Tooltip id={'tooltip'}>{content.isLocked ? 'Asset Locked' : 'Asset Unlocked'}</Tooltip>
                            );

                            const contentName = learningAsset.name;
                            const lockIcon = content.isLocked ? 'far fa-lock' : 'far fa-lock-open';

                            const subscriptionType =
                                learningAsset.subscriptionType === 'ExclusiveCompanyLicense'
                                    ? 'fal fa-landmark'
                                    : 'fas fa-check';

                            const dropdownData = [
                                {
                                    text: 'EDIT ASSET',
                                    fontAwesomeIcon: 'fa-pencil',
                                    fontAwesomeIconWeight: 'fal',
                                    onClick: () => window.open(`/editlearningasset/${content.id}/summary`)
                                },
                                {
                                    text: 'COPY ASSET ID',
                                    fontAwesomeIcon: 'fa-clipboard',
                                    fontAwesomeIconWeight: 'fal',
                                    onClick: () => {
                                        copyIdToClipboard(learningAsset._id);
                                    }
                                },
                                {
                                    text: 'DELETE ASSET',
                                    fontAwesomeIcon: 'fa-trash',
                                    fontAwesomeIconWeight: 'fal',
                                    onClick: () => this._handleContentFieldRemoval(index)
                                }
                            ];
                            return (
                                <tr key={index}>
                                    <td className={'buttonCell'}>
                                        <VerbButton
                                            disabled={index === 0}
                                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                            fontAwesomeIcon={'fa-angle-up'}
                                            onClick={() => fields.swap(index, index - 1)}
                                            title={'Move Up'}
                                        />
                                        <VerbButton
                                            disabled={index === fields.length - 1}
                                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                            fontAwesomeIcon={'fa-angle-down'}
                                            onClick={() => fields.swap(index, index + 1)}
                                            title={'Move Down'}
                                        />
                                        <VerbDropdownButton
                                            fontAwesomeIcon={'fa-ellipsis-h'}
                                            dropdownData={dropdownData}
                                            className={'manage-learning-assets-popover'}
                                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                        />
                                    </td>
                                    <td>
                                        <a href={`/review/learningasset/${content.id}`} target={'_blank'}>
                                            {contentName}
                                        </a>
                                    </td>
                                    <td className={'text-center'}>
                                        <div className={'icon-container type'}>
                                            <OverlayTrigger
                                                placement={'top'}
                                                transition={false}
                                                overlay={lockedToolTip}
                                            >
                                                <i
                                                    className={cns('asset-type-icon fal fa-fw', lockIcon)}
                                                    onClick={() => {
                                                        this._handleLockClick(content, index);
                                                    }}
                                                />
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                    <td className={'text-center'}>
                                        <div className={'icon-container type'}>
                                            <OverlayTrigger placement={'top'} transition={false} overlay={tooltip}>
                                                <i
                                                    className={cns(
                                                        'asset-type-icon fal fa-fw',
                                                        assetTypeIcon,
                                                        learningAsset.type
                                                    )}
                                                />
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                    <td className={'text-center'}>
                                        <div className={'icon-container type'}>
                                            <OverlayTrigger
                                                placement={'top'}
                                                transition={false}
                                                overlay={subscriptionTypeToolTip}
                                            >
                                                <i className={subscriptionType} />
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                    <td className={'text-center'}>
                                        <div className={'icon-container duration'}>
                                            <span className={'asset-duration'}>
                                                {(learningAssetDuration[learningAsset.durationId] &&
                                                    learningAssetDuration[learningAsset.durationId].label) ||
                                                    ''}
                                            </span>
                                        </div>
                                    </td>
                                    <td className={'text-center'}>
                                        {learningAsset.isActive ? <i className={'fal fa-check-circle'} /> : ''}
                                    </td>
                                    <td className={'text-center'}>
                                        <Field
                                            name={`${fieldName}.label`}
                                            className={'col-12 col-sm-12 '}
                                            options={[
                                                {
                                                    label: 'Prework',
                                                    value: 'PREWORK'
                                                },
                                                {
                                                    label: 'Solo',
                                                    value: 'SOLO'
                                                },
                                                {
                                                    label: 'Collaborative',
                                                    value: 'COLLABORATIVE'
                                                },
                                                {
                                                    label: 'Agenda',
                                                    value: 'AGENDA'
                                                },
                                                {
                                                    label: 'Reflection',
                                                    value: 'REFLECTION'
                                                },
                                                {
                                                    label: 'Assessment',
                                                    value: 'ASSESSMENT'
                                                },
                                                {
                                                    label: 'Wrap Up',
                                                    value: 'WRAP UP'
                                                },
                                                {
                                                    label: 'Workshop',
                                                    value: 'WORKSHOP'
                                                },
                                                {
                                                    label: 'Practice',
                                                    value: 'PRACTICE'
                                                },
                                                {
                                                    label: 'Event',
                                                    value: 'EVENT'
                                                },
                                            ]}
                                            component={BasicSelect}
                                            inputClassName={'col-12 col-sm-12 no-padding'}
                                            styleProps={{
                                                horizontal: true,
                                                inputStyle: { bordered: true },
                                                marginBottom: '0px'
                                            }}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </VerbTable>
            );
        }
        return null;
    };

    _handleContentFieldAddition = () => {
        const { selectedTrackId, handleContentAddition, fields, selectedTrack } = this.props;

        if (selectedTrackId) {
            const newAsset = {
                id: selectedTrackId,
                type: selectedTrack.type
            };
            handleContentAddition({
                ...newAsset,
                isLocked: false
            });
            return fields.push(newAsset);
        }
        return null;
    };

    _handleContentFieldRemoval = (index) => {
        const { handleContentRemoval, fields, currentValues } = this.props;
        const removedAsset = currentValues.contentIds[index];

        handleContentRemoval(removedAsset);
        return fields.remove(index);
    };

    _makeLearningAssetSelectOptions = (learningAssetsById = {}) => {
        const { currentValues = {} } = this.props;
        const optionsToReturn = [];
        const currentCollectionContent = keyBy(currentValues.contentIds || [], 'id');
        const learningAssetsArray = Object.values(learningAssetsById);
        let currentLearningAsset;
        for (let i = 0; i < learningAssetsArray.length; i += 1) {
            currentLearningAsset = learningAssetsArray[i];
            if (!(currentLearningAsset._id in currentCollectionContent) && currentLearningAsset.isActive) {
                optionsToReturn.push({
                    _id: currentLearningAsset._id,
                    name: `${currentLearningAsset.name}`
                });
            }
        }
        return optionsToReturn.sort((a, b) => a.name.localeCompare(b.name));
    };

    render() {
        const { learningAssetsById, selectedTrackId, handleLearningAssetChange, fields, label } = this.props;

        const learningAssetOptions = this._makeLearningAssetSelectOptions(learningAssetsById);
        return (
            <div className={'collection-form-content-table col-12'}>
                <h4>{label}</h4>
                <div className={'row'}>
                    <div className={'col-8'}>
                        <VerbSelect
                            placeholder={'Select Content'}
                            className={'reactSelect'}
                            value={selectedTrackId}
                            labelKey={'name'}
                            valueKey={'_id'}
                            onChange={handleLearningAssetChange}
                            options={learningAssetOptions}
                        />
                    </div>
                    <div className={'add-asset-button col-4'}>
                        <VerbButton
                            className={'add-asset-button full-width'}
                            fontAwesomeIcon={'fa-plus'}
                            onClick={this._handleContentFieldAddition}
                        >
                            ADD
                        </VerbButton>
                    </div>
                </div>
                <br />
                {this._buildTable(fields, learningAssetsById)}
            </div>
        );
    }
}
